import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import CreditCard from '@icons/paymentMethod/CreditCard';
import { useTranslation } from 'react-i18next';

function PaymentMethod() {
    const { t } = useTranslation('prepaidCard');
    return (
        <Container as='section'
            spacing={24} >
            <Text fontWeight='bold' size='2xl' color={colors.gray7}>
                {t('components.chargeMethod.title')}
            </Text>
            <div>
                <Column align='center' spacing={8} >
                    <CreditCard size={52} color={colors.primary} />
                    <Text fontWeight='bold'>{t('components.chargeMethod.creditCard')}</Text>
                </Column>
            </div>
        </Container>
    );
}

const Container = styled(Column)`
    padding: 0 20px 36px;
`;

export default PaymentMethod;
